import React from 'react';

import {ErrorModalTemplate} from '../../../components/DataDisplay';
import appConfig from '../../../config/appConfig';
import {ADDITIONAL_RESET_FAILED} from '../../../consts/device/firmwareErrorTypes';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDeviceName from '../../../hooks/useDeviceName';
import useHideModalIfNoDevice from '../../../hooks/useHideModalIfNoDevice';
import fwuTargetService from '../../../services/device/fwuTargetService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import routerService from '../../../services/routerService';
import {hideModalAction} from '../../../state/ducks/modal';
import {dispatch} from '../../../state/store';
import elementsTesIds from '../../../test/consts/elementsTesIds';

const FWUErrorPopup = (props) => {
    const {modalType, errorCode, fwuTarget} = props;
    let titleKey;
    let description;
    let closeButtonKey;
    let primaryButtonKey;
    const localizedStrings = getLocalizedStrings();
    const deviceName = useDeviceName();

    useHideModalIfNoDevice(modalType);

    if (errorCode === ADDITIONAL_RESET_FAILED) {
        titleKey = localizationKeys.FIRMWARE_UPDATE_RESET_FAILED_TITLE;
        description = (
            <p>
                {localizedStrings.formatString(
                    localizedStrings[localizationKeys.FIRMWARE_UPDATE_RESET_FAILED_DESCRIPTION],
                    deviceName
                )}
            </p>
        );
        closeButtonKey = localizationKeys.FIRMWARE_UPDATE_RESET_FAILED_CONFIRM_TEXT;
        primaryButtonKey = undefined;

        if (fwuTargetService.isFwuTargetBleStack(fwuTarget)) {
            description = getBleStackFwuDescription({description, deviceName});
        }
    } else {
        titleKey = localizationKeys.IQOS_DUO_CONTACT_US_POPUP_TITLE;
        description = localizedStrings[localizationKeys.IQOS_DUO_CONTACT_US_POPUP_DESCRIPTION];
        closeButtonKey = localizationKeys.IQOS_DUO_CONTACT_US_POPUP_NOT_NOW_BUTTON_TEXT;
        primaryButtonKey = localizationKeys.IQOS_DUO_CONTACT_US_POPUP_CONTACT_US_BUTTON_TEXT;
    }

    const onClose = () => {
        dispatch(hideModalAction(modalType));
    };

    const onContactSupportClick = () => {
        const supportUrl = appConfig.getDcsSupportUrlFormatted();

        routerService.blankLinkOpen(supportUrl);
    };

    return (
        <ErrorModalTemplate
            titleKey={titleKey}
            descriptionContent={description}
            buttonPrimary={
                primaryButtonKey
                    ? {
                          onClick: onContactSupportClick,
                          textKey: primaryButtonKey,
                          testId: elementsTesIds.PAIRING_SEQUENCE_ERROR_TRY_AGAIN_BTN,
                      }
                    : undefined
            }
            buttonSecondary={{
                onClick: onClose,
                textKey: closeButtonKey,
                testId: elementsTesIds.PAIRING_SEQUENCE_ERROR_SKIP_BTN,
            }}
        />
    );
};

export default FWUErrorPopup;

const getBleStackFwuDescription = ({deviceName, description}) => {
    const localizedStrings = getLocalizedStrings();
    const bleStackDescription = localizedStrings[localizationKeys.FIRMWARE_UPDATE_BLE_STACK_RESET_FAILED_DESCRIPTION];
    const bleStackSubDescription = localizedStrings.formatString(
        localizedStrings[localizationKeys.FIRMWARE_UPDATE_BLE_STACK_RESET_FAILED_SUB_DESCRIPTION],
        deviceName
    );

    if (bleStackDescription || bleStackSubDescription) {
        return (
            <>
                {bleStackDescription}
                {bleStackSubDescription && (
                    <ul
                        className='mt-6 flex max-w-xs list-disc flex-col gap-6 ps-6 text-start'
                        dangerouslySetInnerHTML={{
                            __html: bleStackSubDescription,
                        }}
                    />
                )}
            </>
        );
    }

    return description;
};
